import { useEffect, useRef, useState } from "react";
import { _AccountINFORPO, _CreditProcessMovement, _LoanConfigProfile, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../../../../theme/Component/BasicTable";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import usePaginator from "../../../../../theme/Component/usePaginator";
import useModal, { MODAL_LG, MODAL_md, MODAL_SM, MODAL_XL } from "../../../../../theme/Component/hooks/useModal";
import { DropDown } from "../../../../../theme/Component/DropDown";
import { Modal } from "../../../../../theme/Component/Modal";
import AutoChart from "../../../../../../core/graph/AutoChart";
import { ExportXLSL } from "../../../../../theme/Component/ExportXLSX";
import { AccountEditor } from "../../../../../editor/AccountEditor";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { toast } from "react-toastify";
import { ComponentSettedDistributionValues } from "./ProcesosComponents/ComponentSettedDistributionValues";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { isArray } from "chart.js/dist/helpers/helpers.core";
import { DocumentViewer } from "../../../../../theme/Component/DocumentViewer";

interface Props {
    idCreditProcessMovement: number;
    stateProcessMovement: number;
    yearProcess: number;
    monthProcess: number;
    typeProcess: number;
}
interface formProps {
    IDAccount: number;
    CreditNumber: string;
    EntityName: string;
}
export const ProcessCreditItems = ({ idCreditProcessMovement, stateProcessMovement, yearProcess, monthProcess, typeProcess }: Props) => {

    const _credit = useDataBean(_CreditProcessMovement);
    const _loan = useDataBean(_LoanConfigProfile);
    const _credtiAccount = useDataBean(_AccountINFORPO);
    const _creditProcessMovement = useDataBean(_CreditProcessMovement);
    const { setLista, lista, setBean, bean } = _credit;
    const _config = useDataBean(_LoanConfigProfile);
    const [listaAll, setListaAll] = useState<any>([]);
    const [form, setForm] = useState<Partial<formProps>>({});
    const [cuota, setCuota] = useState<any>({});
    const [creditAccount, setCreditAccount] = useState<any>({});
    const [item, setItem] = useState<any>({
        IDCreditProcessMovement: idCreditProcessMovement,
        YearProcess: yearProcess,
        MonthProcess: monthProcess,
        NoCredit: 0
    });
    const [document, setDocument] = useState<any>({});


    const paginador = usePaginator();
    const modalGraph = useModal("Grafica", MODAL_XL);
    const modalDownload = useModal("Consolidado", MODAL_SM);
    const modalAdd = useModal("Agregar Crédito", MODAL_SM);
    const modalDel = useModal("Eliminar Cuenta de Cobro", MODAL_SM);
    const modalDev = useModal("Reversión Cuenta Cobro", MODAL_SM);
    const modalDocumento = useModal("Documento", MODAL_XL);

    useEffect(() => {
        getCreditProcessItemRender();
    }, [paginador.page])

    const getCreditProcessItemRender = () => {
        const props: any = {
            IDCreditProcessMovement: idCreditProcessMovement
        }

        if (form.CreditNumber) props.CreditNumber = form.CreditNumber;
        if (form.EntityName) props.EntityName = form.EntityName;
        if (form.IDAccount) props.IDAccount = form.IDAccount;

        _credit.instance.getCreditProcessItemRender(paginador.page, 15, props).then(
            (resp: any) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * 15);
                if (resp.List) {
                    resp.List.forEach(element => {
                        element.DataBeanProperties.VrCuota =
                            (element.DataBeanProperties.InteresCorriente ?? 0) +
                            (element.DataBeanProperties.InteresMora ?? 0) +
                            (element.DataBeanProperties.CapitalCorriente ?? 0);

                        element.DataBeanProperties.VrVencido =
                            (element.DataBeanProperties.InteresMora ?? 0) +
                            (element.DataBeanProperties.CapitalMora ?? 0);

                        element.DataBeanProperties.PaidedData = element.DataBeanProperties.PaidedData ?? "";
                    });
                    setLista(resp.List);
                }
            }
        )
    }
    useEffect(() => {
        if (creditAccount.IDCreditAccount > 0) {
            const cuota: any = { ...item };
            cuota.IDCreditAccount = creditAccount.IDCreditAccount;
            cuota.IDAccount = creditAccount.IDAccount;
            cuota.IDLoanLine = creditAccount.IDLoanLine;
            cuota.IDPayrollEntity = creditAccount.IDPayrollEntity;
            cuota.CreditNumber = creditAccount.CreditNumber;
            cuota.PaidedData = JSON.stringify({
                LoanNumber: creditAccount.CreditNumber
            });

            _creditProcessMovement.instance.updateCreditProcessItem(cuota).then(
                (resp: any) => {
                    toast.success("Crédito actualizado");
                    setBean(resp.DataBeanProperties);
                    getCreditProcessItemRender();
                }
            )

        }
    }, [creditAccount])


    const getCredito = () => {
        const filtro = {
            CreditNumber: item.NoCredit,
            Year: _single.getCurrenYear(),
            Month: _single.getCurrentMonth()

        }
        _credtiAccount.instance.getCarteraRender(1, 20, filtro).then(
            (resp: any) => {
                let lista = resp.List ?? [];
                if (lista.length > 0) {
                    let credito = lista[0].DataBeanProperties;
                    if (credito) {
                        if (credito.State == 724) {
                            setCreditAccount(credito);
                        } else {
                            toast.warning("El Crédito que intenta agregar esta en estado " + credito.StateName);

                        }

                    } else {
                        toast.warning("No se encontro crédito");
                    }
                }
                modalAdd.close();
            }
        )
    }
    const eliminarCuenta = () => {
        _creditProcessMovement.instance.deleteCreditProcessItem(bean.IDCreditProcessItem).then(
            (resp: any) => {
                getCreditProcessItemRender();
                modalDel.close();
            }
        )
    }

    const recalcularCuota = () => {
        _credit.instance.recalcularCuota(bean.IDCreditProcessMovement, bean.IDCreditAccount).then(
            (resp: any) => {
                getCreditProcessItemRender();
                toast.success("Cuota Actualizada");
            }
        )
    }
    const recalcularCuotasByMovement = () => {
        _credit.instance.recalcularCuotasByMovement(idCreditProcessMovement).then(
            (resp: any) => {
                getCreditProcessItemRender();
                toast.success("Cuotas Actualizada");
            }
        )
    }


    const head = [
        { title: 'ID', property: 'IDCreditProcessItem', visible: false, mask: MASK_NUMBER },
        { title: 'Fecha Cuota', property: 'CuotaDate', visible: true, mask: MASK_DATE },
        { title: 'Crédito', property: 'CreditNumber', visible: true },
        { title: 'Linea', property: 'LoanName', visible: true },
        { title: 'Identificación', property: 'Nit', visible: true, mask: MASK_NUMBER },
        { title: 'Tercero', property: 'EntityName', visible: true },
        { title: 'Valor Cuota', property: 'VrCuota', visible: true, mask: MASK_MONEY },
        { title: 'Capital Corriente', property: 'CapitalCorriente', visible: true, mask: MASK_MONEY },
        { title: 'Interes Corriente', property: 'InteresCorriente', visible: true, mask: MASK_MONEY },
        { title: 'Interes Mora', property: 'InteresMora', visible: true, mask: MASK_MONEY },
        { title: 'Capital Mora', property: 'CapitalMora', visible: true, mask: MASK_MONEY },
        { title: 'Valor Vencido', property: 'VrVencido', visible: true, mask: MASK_MONEY },
        // { title: 'Interes Mora Acumulado', property: 'SaldoMoraInteres', visible: true, mask: MASK_MONEY },
        // { title: 'Mayor Valor', property: 'HighestPaidAmount', visible: true, mask: MASK_MONEY },
        // { title: 'Interes Mora ', property: 'InteresMora', visible: true, mask: MASK_MONEY },
        { title: 'Saldo Capital', property: 'SaldoCapital', visible: true, mask: MASK_MONEY },
        { title: 'Fecha Contabilización', property: 'AccountingDate', visible: true, mask: MASK_DATE },
        { title: 'ID Registro', property: 'IDPaymentItem', visible: false, mask: MASK_NUMBER },
        { title: 'Fecha Registro', property: 'PaymentItemDate', visible: false },
        { title: 'Mensaje', property: 'ErrorMessage', visible: true }
    ]
    const headMayor = [
        { title: 'ID', property: 'IDCreditProcessItem', visible: false, mask: MASK_NUMBER },
        { title: 'Fecha Cuota', property: 'CuotaDate', visible: true, mask: MASK_DATE },
        { title: 'Crédito', property: 'CreditNumber', visible: true },
        { title: 'Linea', property: 'LoanName', visible: true },
        { title: 'Identificación', property: 'Nit', visible: true, mask: MASK_NUMBER },
        { title: 'Tercero', property: 'EntityName', visible: true },
        // { title: 'Valor Cuota', property: 'VrCuota', visible: true, mask: MASK_MONEY },
        // { title: 'Valor Vencido', property: 'VrVencido', visible: true, mask: MASK_MONEY },
        // { title: 'Capital Corriente', property: 'CapitalCorriente', visible: true, mask: MASK_MONEY },
        // { title: 'Interes Corriente', property: 'InteresCorriente', visible: true, mask: MASK_MONEY },
        // { title: 'Capital Mora', property: 'CapitalMora', visible: true, mask: MASK_MONEY },
        // { title: 'Interes Mora Acumulado', property: 'SaldoMoraInteres', visible: true, mask: MASK_MONEY },
        { title: 'Mayor Valor', property: 'HighestPaidAmount', visible: true, mask: MASK_MONEY },
        // { title: 'Interes Mora ', property: 'InteresMora', visible: true, mask: MASK_MONEY },
        // { title: 'Saldo Capital', property: 'SaldoCapital', visible: true, mask: MASK_MONEY },
        { title: 'Fecha Contabilización', property: 'AccountingDate', visible: true, mask: MASK_DATE },
        { title: 'ID Registro', property: 'IDPaymentItem', visible: false, mask: MASK_NUMBER },
        { title: 'Fecha Registro', property: 'PaymentItemDate', visible: false },
        { title: 'Mensaje', property: 'ErrorMessage', visible: true }
    ]


    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: () => { modalAdd.open() } }
    ]

    const iniciarDevolucion = () => {
        modalDev.open();
        getCuotaByIDAccount();
    }
    const getCuotaByIDAccount = () => {

        _config.instance.getCuotaByIDAccount(bean.IDAccount, null, yearProcess, monthProcess, bean.VrCuota).then(
            (resp: any) => {

                if (resp) {
                    console.log(resp);
                    if (resp) {
                        if (Array.isArray(resp)) {
                            resp.forEach(element => {
                                element.ReverseCreditQuota = true;
                                element.IDLoanAccount = bean.IDAccount;
                                element.Value = 0;
                            });
                            setCuota(resp);
                        }
                        else {
                            toast.error("No se encontro la cuota");
                        }
                    }

                }
            }
        )
    }
    const aplicarDevolucion = () => {

        if (cuota.length === 0) {
            toast.error("No se encontro la cuota");
            return;
        }
        const customProcessType = 51;
        const idBudgetAccountantOperation = 251;
        _loan.instance.parseQuotaCreditListForReverse(yearProcess, monthProcess, customProcessType,
            ultimoDiaMes(yearProcess, monthProcess + 1), idBudgetAccountantOperation, cuota, _single.getAccountID()).then(
                (resp) => {
                    if (resp.ReportList) {
                        setDocument(resp.ReportList);
                        toast.success("Devolución aplicada");
                        modalDocumento.open()
                    } else {
                        toast.warning("Documento con novedades no se pudo aplicar");
                    }
                }
            ).catch(err => { toast.error(err) });
    }
    function ultimoDiaMes(year, month) {
        // month: 1 = enero, 12 = diciembre
        // En JS, el mes es 0-based, por eso usamos month
        const fecha = new Date(year, month, 0);

        const yyyy = fecha.getFullYear();
        const MM = String(fecha.getMonth() + 1).padStart(2, '0');
        const dd = String(fecha.getDate()).padStart(2, '0');

        return `${yyyy}-${MM}-${dd} 00:00:00`;
    }


    const listaBotones = () => {
        const botones = [
            { titulo: 'Modificar Pagos', icono: 'ri-edit-2-line', visible: Boolean(bean?.PaidedData), evento: () => { cargarDistribucion(); } },
            // { titulo: 'Actualizar Cuota', icono: 'ri-arrow-up-down-fill', visible: Boolean(bean?.PaidedData), evento: () => { recalcularCuota(); } },
            { titulo: 'Actualizar Cuota', icono: 'ri-arrow-up-down-fill', visible: stateProcessMovement != 2, evento: () => { recalcularCuota(); } },
            { titulo: 'Reversión Cuenta Cobro', icono: 'ri-arrow-go-back-fill', visible: stateProcessMovement != 2, evento: () => { iniciarDevolucion(); } },
            { titulo: 'Eliminar', icono: 'ri-eraser-line', visible: stateProcessMovement != 2 && Boolean(bean?.IDCreditProcessItem), evento: () => { modalDel.open() } },
        ];
        return <ListMenu listaBotones={botones} />;
    };
    const actionsDropDown = [
        { id: 1, name: 'Reporte Gráfico', permiso: null, activo: true },
        { id: 2, name: 'Descargar Detallado', permiso: null, activo: true },
        { id: 3, name: 'Recalcular Cuotas', permiso: null, activo: [100].includes(typeProcess) },
    ];
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-4">
                    <AccountEditor idAccount={form.IDAccount} label="Tercero" onChange={(e) => { setForm({ ...form, IDAccount: e.IDAccount }) }} />
                </div>
                <div className="col-md-4">
                    <label>Crédito</label>
                    <input type="text" value={form.CreditNumber} onChange={(e) => { setForm({ ...form, CreditNumber: e.target.value }) }} className="form-control" />
                </div>
                <div className="col-md-4">
                    <BasicButton useMargin eventClick={() => { getCreditProcessItemRender() }} icon="ri-search-line" children={`Buscar`} />
                </div>

                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={(e) => {
                        if (e.id == 1) {
                            modalGraph.open();
                        }
                        if (e.id == 2) {
                            _credit.instance.getCreditProcessItemRender(paginador.page, (paginador.pages * 15) + 20, { IDCreditProcessMovement: idCreditProcessMovement }).then(
                                (resp: any) => {
                                    paginador.setPages(resp.NumberOfPages);
                                    paginador.setRecords(resp.NumberOfPages * 15);
                                    if (resp.List) {
                                        resp.List.forEach(element => {
                                            element.DataBeanProperties.VrCuota =
                                                (element.DataBeanProperties.InteresCorriente ?? 0) +
                                                (element.DataBeanProperties.CapitalCorriente ?? 0);

                                            element.DataBeanProperties.VrVencido =
                                                (element.DataBeanProperties.InteresMora ?? 0) +
                                                (element.DataBeanProperties.CapitalMora ?? 0);

                                            element.DataBeanProperties.PaidedData = element.DataBeanProperties.PaidedData ?? "";
                                        });
                                        setListaAll(resp.List);
                                    }
                                    modalDownload.open();
                                }
                            )
                        }
                        if (e.id == 3) {
                            recalcularCuotasByMovement();
                        }
                    }}></DropDown>
                </div>
            </div>
        )
    }

    const distributionValues = useRef<any>(null);
    const [concept, setConcept] = useState<any>([]);

    const cargarDistribucion = () => {
        _config.instance.getLoanConceptCatalogForQuotaDataForm(bean.IDLoanConfigProfile).then(
            (resp: any) => {
                setConcept(resp);
                distributionValues.current?.openModal();
            }
        ).catch(
            err => {
                toast.error("No se pudo cargar la lista de conceptos")
            }
        )
    }
    const safeParsePaided = (v: any) => {
        try {
            if (!v) return {};
            if (typeof v === "string") return JSON.parse(v);
            if (typeof v === "object") return v; // ya viene como objeto
            return {};
        } catch {
            return {};
        }
    };

    const getHeaderTable = () => {
        if (typeProcess == 102)
            return headMayor;
        else
            return head;
    }



    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable
                    body={lista}
                    head={getHeaderTable()}
                    rowSet={setBean}
                    iconButtons={iconButtonsItem}
                    headButtons={buttons()}
                    records={paginador}
                    listButtons={listaBotones()}
                ></BasicTable>

                {bean?.PaidedData && (
                    <ComponentSettedDistributionValues
                        onChange={(e) => { }}
                        DataPayd={bean ?? {}}
                        ref={distributionValues}
                        functionModalEvent={() => distributionValues.current?.closeModal()}
                        listParameters={[...concept]}
                        value={safeParsePaided(bean?.PaidedData)}
                    />
                )}
                <Modal modal={modalGraph.modal} updateModal={modalGraph.setModal}>
                    <AutoChart data={lista} head={head} useIndexAsXLabel={true}
                        xOptions={['LoanName', 'CuotaDate']}
                        yOptions={['CapitalCorriente', 'InteresCorriente', 'CapitalMora', 'InteresMora', 'SaldoCapital']} />

                </Modal>
                <ModalConfirm modal={modalDev.modal} updateModal={modalDev.setModal} eventModal={aplicarDevolucion}>
                    <div className="row">
                        <div className="col-md-12">
                            Reversión Cuenta Cobro crédito No. {bean?.CreditNumber}
                            {/* <PrintJson json={cuota} /> */}
                        </div>
                    </div>

                </ModalConfirm>
                <Modal modal={modalDocumento.modal} updateModal={modalDocumento.setModal}>
                    <DocumentViewer list={document} />
                </Modal>

                <Modal modal={modalDownload.modal} updateModal={modalDownload.setModal}>
                    <div className="row">
                        <div className="col-md-12">
                            {listaAll.length > 0 &&
                                <ExportXLSL customName={'cartera'} optionIcon="ri-download-cloud-2-line text-success" title={getHeaderTable()} data={listaAll} onExport={(name: string) => {
                                    _single.download("formato xlsx [" + name + "] con " + lista.length + " registros");
                                }} />
                            }
                        </div>
                    </div>

                </Modal>
                <Modal modal={modalAdd.modal} updateModal={modalAdd.setModal} eventModal={getCredito} onSubmitLabel="Agregar">
                    <div className="row">
                        <div className="col-md-12">
                            <label>No Crédito</label>
                            <input type="number" name="NoCredit" className="form-control" value={item.NoCredit} onChange={(e) => { setItem({ ...item, "NoCredit": parseInt(e.target.value) }) }} />
                        </div>
                        {/* <div className="col-md-12">
                            <PrintJson json={creditAccount} />
                        </div> */}
                    </div>
                </Modal>
                <ModalConfirm modal={modalDel.modal} updateModal={modalDel.setModal} eventModal={eliminarCuenta}>
                    <p>Eliminar registro</p>
                </ModalConfirm>
            </div>
        </div>
    )
}